// extracted by mini-css-extract-plugin
module.exports = {"contents":"_1YF_P8vctGDaiGQJRxaUOG"};